import { store } from "../app/store";
import { vendors } from "./vendors";
import { app } from "./app";
import { common } from "./common";
import { cart } from "./cart";
import { product } from "./product";
import { user } from "./user";
import { checkout } from "./checkout";
import { order } from "./order";
import { compare } from "./compare";
import { wishlist } from "./wishlist";
import { savedForLater } from "./savedForLater";
import { featured } from "./featured";
import { stockNotification } from "./stockNotification";
import { forms } from "./forms";
import { parts } from "./parts";

const EcommerceCore = {
  version: "1.0.0",
  store,

  vendors,
  app,
  common,
  cart,
  product,
  user,
  checkout,
  order,
  compare,
  wishlist,
  savedForLater,
  featured,
  stockNotification,
  forms,
  parts,
};

window.EcommerceCore = EcommerceCore;
export default EcommerceCore;
